// extracted by mini-css-extract-plugin
export default {"wrapper":"DraggableSlider__wrapper--nimph","dragging":"DraggableSlider__dragging--Qj95t"};